import React, { useState } from 'react';
import './Contact.css';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import { Button, CircularProgress } from '@material-ui/core';
import CustomAlert from './CustomAlert';
import { send } from 'emailjs-com';
import { useHistory } from 'react-router-dom';
import { createQueryDocument } from '../Backend/firebase/contact';

const generateRandomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min) + min);
};

function ContactForm() {
    const { register, handleSubmit, errors, reset } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const history = useHistory();
    const [firstRandomNumber, setFirstRandomNumber] = useState(generateRandomNumber(1, 20));
    const [secondRandomNumber, setSecondRandomNumber] = useState(generateRandomNumber(1, 20));

    const onSubmit = async (data) => {
        setIsLoading(true);
        // var additionValue = firstRandomNumber + secondRandomNumber;
        // if (data.validateCaptcha !== '' && data.validateCaptcha === String(additionValue)) {
            var templateParameter = {
                subject: data.subject,
                fullName: data.fullName,
                eventType: data.eventType,
                email: data.email,
                description: data.description,
                phoneNumber: data.phoneNumber
            }

            try {
                var query = createQueryDocument(templateParameter);
                if (query) {
                    setAlertType('success');
                    setNotificationMessage('We have received your information successfully.!');
                    setOpenNotify(true);
                    reset();
                    setIsLoading(false);
                    setTimeout(reloadPages, 2000);
                    setFirstRandomNumber(generateRandomNumber(1, 20));
                    setSecondRandomNumber(generateRandomNumber(1, 20));
                } else {
                    setNotificationMessage('Something went wrong, Please try again later!!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsLoading(false);
                }
            }  catch (error) {
                console.error(error);
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
            }

            // var response = await send(process.env.REACT_APP_EMAIL_SERVICE_ID, process.env.REACT_APP_EMAIL_TEMPLATE_ID,
            //     templateParameter, process.env.REACT_APP_EMAIL_USER_ID);
            // if (response.status === 200) {
            //     setAlertType('success');
            //     setNotificationMessage('We have received your information successfully.!');
            //     setOpenNotify(true);
            //     reset();
            //     setIsLoading(false);
            //     setTimeout(reloadPages, 2000);
            //     setFirstRandomNumber(generateRandomNumber(1, 20));
            //     setSecondRandomNumber(generateRandomNumber(1, 20));
            // }
        // } else {
        //     setAlertType('error');
        //     setNotificationMessage('Please verify the captcha first!');
        //     setOpenNotify(true);
        //     setIsLoading(false);
        // }
    }

    const reloadPages = () => {
        history.push('/contact');
    }

    return (
        <div className="contactForm">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    <div className="col-md-12 mt-2">
                        {/* Category <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span> */}
                        <select className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.eventType })} aria-label="Default select example"
                            name="eventType" ref={register({
                                required: 'Please select any eventType!',
                                validate: {
                                    defaultValue: value => value !== "Select Category" || 'Please select any eventType!'
                                }
                            })} defaultValue="Select Category">
                            <option value="Select Category">Select Category</option>
                            <option value="Request Information">Request Information</option>
                            <option value="Report a problem">Report a problem</option>
                            <option value="Partnership">Partnership</option>
                            <option value="Suggestion">Suggestion</option>
                        </select>
                        <small className="form-text text-danger">{errors.eventType && errors.eventType.message}</small>
                    </div>
                    <div className="col-md-12 mt-3">
                        {/* Full Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span> */}
                        <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.fullName })}
                            name="fullName" placeholder="Full Name" autoComplete="none"
                            ref={register({ required: 'Please enter your full name!' })} />
                        <small className="form-text text-danger">{errors.fullName && errors.fullName.message}</small>
                    </div>
                    <div className="col-md-12 mt-3">
                        {/* Email <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span> */}
                        <input type="email" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.email })}
                            name="email" placeholder="Email Address" autoComplete="none"
                            ref={register({ required: 'Please enter your name!' })} />
                        <small className="form-text text-danger">{errors.email && errors.email.message}</small>
                    </div>
                    <div className="col-md-12 mt-3">
                        {/* Telephone <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span> */}
                        <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.phoneNumber })}
                            name="phoneNumber" placeholder="Telephone" autoComplete="off"
                            ref={register({
                                minLength: {
                                    value: 10,
                                    message: 'Phone number should be at least 10 digits!'
                                },
                                maxLength: {
                                    value: 10,
                                    message: 'Phone number should be 10 length maximum!'
                                },
                                required: 'Please enter the telephone number!'
                            })} />
                        <small className="form-text text-danger">{errors.phoneNumber && errors.phoneNumber.message}</small>
                    </div>
                    <div className="col-md-12 mt-3">
                        {/* Subject <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span> */}
                        <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.subject })}
                            name="subject" placeholder="Subject" autoComplete="none"
                            ref={register({ required: 'Please enter the subject!' })} />
                        <small className="form-text text-danger">{errors.subject && errors.subject.message}</small>
                    </div>
                    <div className="col-md-12 mt-3">
                        {/* Description <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span> */}
                        <textarea type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.description })}
                            name="description" placeholder="Description" autoComplete="none"
                            ref={register({ required: 'Please enter the description!' })}></textarea>
                        <small className="form-text text-danger">{errors.description && errors.description.message}</small>
                    </div>
                    {/* <div className="col-md-12 offset-md-3 mt-3">
                        <div className="d-flex justify-content-flexend">
                            <div className="mt-2" style={{fontSize: '18px'}}>{firstRandomNumber} + {secondRandomNumber}</div>
                            <div style={{marginLeft: '20px'}}>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.validateCaptcha })}
                                    name="validateCaptcha" placeholder="Enter Value" autoComplete="none"
                                    ref={register({ required: 'Please enter the addition value!' })} />
                                <small className="form-text text-danger">{errors.validateCaptcha && errors.validateCaptcha.message}</small>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-md-12 mt-3 offset-md-9">
                        <div className="d-flex">
                            <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                {isLoading ? <CircularProgress size={18} /> : 'Submit'}
                            </Button>
                        </div>
                    </div>
                </div>
            </form>

            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </div>
    )
}

export default ContactForm
